<div class="settlements-tab">
  <p-table [value]="batches" [loading]="loading" styleClass="p-datatable-sm p-datatable-striped">
    <ng-template pTemplate="header">
      <tr>
        <th>Settlement Batch</th>
        <th>Email Date</th>
        <th>Truck</th>
        <th class="text-right">Projected Earnings</th>
        <th class="text-right">Fuel</th>
        <th class="text-right">Non-Fuel</th>
        <th class="text-right">Reimbursement</th>
        <th class="text-right">Total Deductions</th>
        <th class="text-right">Net</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-batch>
      <tr>
        <td>
          <a
            *ngIf="canViewSettlementsLoads"
            [routerLink]="['/settlements/loads', driver.id]"
            [queryParams]="{ batchNo: batch.batchNo }"
            >{{ batch.batchNo }}</a
          >
          <span *ngIf="!canViewSettlementsLoads">{{ batch.batchNo }}</span>
        </td>
        <td>{{ batch.createdAt | date: "MM/dd/yyyy" }}</td>
        <td>{{ batch.unitNumber || "N/A" }}</td>
        <td class="text-right" [ngClass]="{ 'negative-value': batch.earnProjected < 0 }">
          {{ batch.earnProjected | currency: "USD" : "symbol" : "1.2-2" }}
        </td>
        <td class="text-right" [ngClass]="{ 'negative-value': batch.fuelAmount < 0 }">
          {{ batch.fuelAmount | currency: "USD" : "symbol" : "1.2-2" }}
        </td>
        <td class="text-right" [ngClass]="{ 'negative-value': batch.nonFuel < 0 }">
          {{ batch.nonFuel | currency: "USD" : "symbol" : "1.2-2" }}
        </td>
        <td class="text-right" [ngClass]="{ 'negative-value': batch.reimbursement < 0 }">
          {{ batch.reimbursement | currency: "USD" : "symbol" : "1.2-2" }}
        </td>
        <td class="text-right" [ngClass]="{ 'negative-value': batch.totalDeductions < 0 }">
          {{ batch.totalDeductions | currency: "USD" : "symbol" : "1.2-2" }}
        </td>
        <td class="text-right" [ngClass]="{ 'negative-value': batch.totalSettlement < 0 }">
          {{ batch.totalSettlement | currency: "USD" : "symbol" : "1.2-2" }}
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="9" class="text-center">No settlement batches found for this driver.</td>
      </tr>
    </ng-template>
  </p-table>
</div>
